// Check variant shipping availability

// Update button text based on availability
function updateButtonText() {
  const submitButton = document.querySelector('.quantity-submit-row__submit input');
  if (submitButton) {
    const isDisabled = submitButton.hasAttribute('disabled') || submitButton.disabled;
    if (isDisabled) {
      submitButton.value = 'Sold out';
    } else {
      submitButton.value = 'Add to cart';
    }
  }
}

// Set up button text observer
function setupButtonTextObserver() {
  const submitButton = document.querySelector('.quantity-submit-row__submit input');
  if (submitButton) {
    // Create a mutation observer to watch for attribute changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          updateButtonText();
        }
      });
    });
    
    // Start observing the button for attribute changes
    observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled']
    });
    
    // Also listen for property changes
    const originalDisabledSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'disabled').set;
    Object.defineProperty(submitButton, 'disabled', {
      set: function(value) {
        originalDisabledSetter.call(this, value);
        updateButtonText();
      },
      get: function() {
        return this.hasAttribute('disabled');
      }
    });
  }
}

function checkShippingAvailability() {
  var selectedVariant = document.querySelector('.variant-id').getAttribute('data-variant');
  if (selectedVariant !== undefined && selectedVariant !== 'undefined' && selectedVariant !== null) {
    document.querySelectorAll('.original-selector option').forEach(function (variant) {
      var variantID = variant.getAttribute('value');
      
      if (variantID === selectedVariant) {
        var variantInventory = variant.getAttribute('data-inventory-shipping');
        var variantShippingObject = JSON.parse(document.getElementById('variant-shipping').innerText);

        if (Object.keys(variantShippingObject)[0]) {
          for (const [key, value] of Object.entries(variantShippingObject)) {
            if (key === variantID) {
              const availableElem = document.querySelector('.available-to-sell');

              const datePlusSix = new Date();
              for (let i = 0; i < 6;) {
                datePlusSix.setDate(datePlusSix.getDate() + 1);
                if (datePlusSix.getDay() !== 0) {
                  i++;
                }
              }
              const formattedDatePlusSix = `${datePlusSix.toLocaleString('default', {month: 'short'})} ${datePlusSix.getDate()}`;

              const datePlusSeven = new Date(datePlusSix);
              for (let i = 0; i < 1;) {
                datePlusSeven.setDate(datePlusSeven.getDate() + 1);
                if (datePlusSeven.getDay() !== 0) {
                  i++;
                }
              }
              const formattedDatePlusSeven = `${datePlusSeven.toLocaleString('default', {month: 'short'})} ${datePlusSeven.getDate()}`;

              const truckSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="a" width="30" height="22" viewBox="0 0 42 32" style="fill: #00713A;width:22px;"><path id="b" d="m42,16.69l-7.65-9.84h-6.68V0H0v27.16h4.52c.36,2.72,2.75,4.84,5.66,4.84s5.3-2.12,5.66-4.84h6.77c.36,2.72,2.75,4.84,5.66,4.84s5.3-2.12,5.66-4.84h8.07v-10.47Zm-31.82,13.43c-2.09,0-3.79-1.65-3.79-3.67s1.7-3.67,3.79-3.67,3.79,1.65,3.79,3.67-1.7,3.67-3.79,3.67Zm12.49-4.84h-6.9c-.56-2.5-2.85-4.37-5.6-4.37s-5.04,1.88-5.6,4.37H1.95V1.88h23.78v19.63c-1.53.74-2.68,2.11-3.05,3.77Zm5.6,4.84c-2.09,0-3.79-1.65-3.79-3.67s1.7-3.67,3.79-3.67,3.79,1.65,3.79,3.67-1.7,3.67-3.79,3.67Zm11.78-4.84h-6.18c-.56-2.5-2.85-4.37-5.6-4.37-.21,0-.4.04-.61.06v-12.23h5.71l6.68,8.59v7.96Z"/></svg>`;
              const tooltipSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="a" width="16" height="16" viewBox="0 0 32 32" style="fill: gray;width:16px;margin-top:-5px;"><path id="b" d="m16,0C7.16,0,0,7.16,0,16s7.16,16,16,16,16-7.16,16-16S24.84,0,16,0Zm1.6,26.5h-3v-3h3v3Zm1.04-9.23c-.7.29-1.16.98-1.16,1.74v1.5h-2.96v-1.5c0-1.99,1.19-3.77,3.01-4.52,1.41-.58,2.01-1.43,2.01-2.76,0-1.76-1.56-3.22-3.54-3.22s-3.54,1.47-3.54,3.22v1.5h-2.96v-1.5c0-3.46,2.93-6.22,6.5-6.22s6.5,2.76,6.5,6.22c0,2.59-1.36,4.51-3.86,5.54Z"/></svg>`;

              if (variantInventory >= 1) {
                availableElem.innerHTML = `
                  <div style="display:flex;align-items:flex-start;">
                    ${truckSVG}
                    <div style="margin-left:12px;font-size:15px;">Usually ships within same or next business day</div>
                  </div>
                  <div class="tooltip-container" style="display:none">
                    <div style="color:#454545;font-size:15px;font-weight:400;margin-left:32px;">Estimated arrival to you: <span style="color: #00713A;margin:0 1px;font-weight:700;">${formattedDatePlusSeven}</span> or <span style="color: #00713A;font-style: normal;margin:0 1px;font-weight:400;">sooner</span>
                      <div class="tooltip">
                        ${tooltipSVG}                      
                        <div class="tooltip-content" style="color:#454545;font-size:15px;">
                          <span class="close-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>
                          <div class="section" style="padding-top:10px;">
                            <strong>UPS Ground</strong>
                            <p style="margin:5px 0 0;font-weight: 400;">Estimated arrival to you: <span style="color: #00713A;font-weight: 700;">${formattedDatePlusSix}</span></p>
                          </div>
                          <hr style="height:0;margin: 12px 0;">
                          <div class="section">
                            <strong>UPS SurePost</strong>
                            <p style="margin:5px 0 0;font-weight: 400;">Estimated arrival to you: <span style="color: #00713A;font-weight: 700;">${formattedDatePlusSeven}</span></p>
                          </div>
                          <hr style="height:0;margin: 12px 0;">
                          <div class="section" style="margin-bottom:5px; 0">
                            <em style="font-weight: 400;">You can select the delivery method during checkout</em>
                          </div>
                          <div class="arrow"></div>
                        </div>
                      </div>                    
                    </div>
                      <span style="padding-left: 4px"> | FREE Shipping over $99*</span>     
                  </div>`;

                const tooltipIcon = availableElem.querySelector('.tooltip');
                const tooltipContent = availableElem.querySelector('.tooltip-content');
                const closeBtn = availableElem.querySelector('.close-btn');

                tooltipIcon.addEventListener('click', function (e) {
                  if (e.target.closest('.tooltip-content')) return;

                  const isTooltipVisible = tooltipContent.style.display === 'block';
                  tooltipContent.style.display = isTooltipVisible ? 'none' : 'block';
                });

                closeBtn.addEventListener('click', function () {
                  tooltipContent.style.display = 'none';
                });

                document.addEventListener('click', function (e) {
                  if (tooltipContent.style.display !== 'block') {
                    return;
                  }

                  if (e.target.closest('.tooltip-content') || e.target.closest('.tooltip')) {
                    return;
                  }

                  tooltipContent.style.display = 'none';
                });
              } else {
                availableElem.innerHTML = '';
              }

              if (value === 'Always' || value === 'Ok') {
                availableElem.innerHTML = 'Usually ships direct from the manufacturer within 1-4 business days.';
              }
            }
          }
        } else {
          const availableElem = document.querySelector('.available-to-sell');

          const datePlusSix = new Date();
          for (let i = 0; i < 6;) {
            datePlusSix.setDate(datePlusSix.getDate() + 1);
            if (datePlusSix.getDay() !== 0) {
              i++;
            }
          }
          const formattedDatePlusSix = `${datePlusSix.toLocaleString('default', {month: 'short'})} ${datePlusSix.getDate()}`;

          const datePlusSeven = new Date(datePlusSix);
          for (let i = 0; i < 1;) {
            datePlusSeven.setDate(datePlusSeven.getDate() + 1);
            if (datePlusSeven.getDay() !== 0) {
              i++;
            }
          }
          const formattedDatePlusSeven = `${datePlusSeven.toLocaleString('default', {month: 'short'})} ${datePlusSeven.getDate()}`;

          const truckSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="a" width="34" height="25" viewBox="0 0 42 32" style="fill: #00713A;width:20px;"><path id="b" d="m42,16.69l-7.65-9.84h-6.68V0H0v27.16h4.52c.36,2.72,2.75,4.84,5.66,4.84s5.3-2.12,5.66-4.84h6.77c.36,2.72,2.75,4.84,5.66,4.84s5.3-2.12,5.66-4.84h8.07v-10.47Zm-31.82,13.43c-2.09,0-3.79-1.65-3.79-3.67s1.7-3.67,3.79-3.67,3.79,1.65,3.79,3.67-1.7,3.67-3.79,3.67Zm12.49-4.84h-6.9c-.56-2.5-2.85-4.37-5.6-4.37s-5.04,1.88-5.6,4.37H1.95V1.88h23.78v19.63c-1.53.74-2.68,2.11-3.05,3.77Zm5.6,4.84c-2.09,0-3.79-1.65-3.79-3.67s1.7-3.67,3.79-3.67,3.79,1.65,3.79,3.67-1.7,3.67-3.79,3.67Zm11.78-4.84h-6.18c-.56-2.5-2.85-4.37-5.6-4.37-.21,0-.4.04-.61.06v-12.23h5.71l6.68,8.59v7.96Z"/></svg>`;
          const tooltipSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="a" width="16" height="16" viewBox="0 0 32 32" style="fill: gray;width:16px;margin-top:-5px;"><path id="b" d="m16,0C7.16,0,0,7.16,0,16s7.16,16,16,16,16-7.16,16-16S24.84,0,16,0Zm1.6,26.5h-3v-3h3v3Zm1.04-9.23c-.7.29-1.16.98-1.16,1.74v1.5h-2.96v-1.5c0-1.99,1.19-3.77,3.01-4.52,1.41-.58,2.01-1.43,2.01-2.76,0-1.76-1.56-3.22-3.54-3.22s-3.54,1.47-3.54,3.22v1.5h-2.96v-1.5c0-3.46,2.93-6.22,6.5-6.22s6.5,2.76,6.5,6.22c0,2.59-1.36,4.51-3.86,5.54Z"/></svg>`;

          if (variantInventory >= 1) {
            availableElem.innerHTML = `
                  <div class="tooltip-container" style="display:none">
                    ${truckSVG}
                    <div style="color:#454545;font-size:15px;font-weight:400;margin-left:12px;">Estimated arrival to you: <span style="color: #00713A;margin:0 1px;font-weight:700;">${formattedDatePlusSeven}</span> or <span style="color: #00713A;font-style: normal;margin:0 1px;font-weight:400;">sooner</span>
                      <div class="tooltip">
                        ${tooltipSVG}                      
                        <div class="tooltip-content" style="color:#454545;font-size:15px;">
                          <span class="close-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>
                          <div class="section" style="padding-top:10px;">
                            <strong>UPS Ground</strong>
                            <p style="margin:5px 0 0;font-weight: 400;">Estimated arrival to you: <span style="color: #00713A;font-weight: 700;">${formattedDatePlusSix}</span></p>
                          </div>
                          <hr style="height:0;margin: 12px 0;">
                          <div class="section">
                            <strong>UPS SurePost</strong>
                            <p style="margin:5px 0 0;font-weight: 400;">Estimated arrival to you: <span style="color: #00713A;font-weight: 700;">${formattedDatePlusSeven}</span></p>
                          </div>
                          <hr style="height:0;margin: 12px 0;">
                          <div class="section" style="margin-bottom:5px; 0">
                            <em style="font-weight: 400;">You can select the delivery method during checkout</em>
                          </div>
                          <div class="arrow"></div>
                        </div>
                      </div>                    
                    </div>  
                      <span style="padding-left: 4px"> | FREE Shipping over $99*</span>            
                  </div>`;

            const tooltipIcon = availableElem.querySelector('.tooltip');
            const tooltipContent = availableElem.querySelector('.tooltip-content');
            const closeBtn = availableElem.querySelector('.close-btn');

            tooltipIcon.addEventListener('click', function (e) {
              if (e.target.closest('.tooltip-content')) return;

              const isTooltipVisible = tooltipContent.style.display === 'block';
              tooltipContent.style.display = isTooltipVisible ? 'none' : 'block';
            });

            closeBtn.addEventListener('click', function () {
              tooltipContent.style.display = 'none';
            });

            document.addEventListener('click', function (e) {
              if (tooltipContent.style.display !== 'block') {
                return;
              }

              if (e.target.closest('.tooltip-content') || e.target.closest('.tooltip')) {
                return;
              }

              tooltipContent.style.display = 'none';
            });
          } else {
            availableElem.innerHTML = '';
          }
        }
      }
    });
  } else {
    //const shipValue = Object.values(JSON.parse(document.getElementById('variant-shipping').innerText))[0];

    const availableElem = document.querySelector('.available-to-sell');

   /* if (shipValue === 'Always' || shipValue === 'Ok') {
      availableElem.innerHTML = 'Usually ships direct from the manufacturer within 1-4 business days.';
      return;
    }
*/
    const datePlusSix = new Date();
    for (let i = 0; i < 6;) {
      datePlusSix.setDate(datePlusSix.getDate() + 1);
      if (datePlusSix.getDay() !== 0) {
        i++;
      }
    }
    const formattedDatePlusSix = `${datePlusSix.toLocaleString('default', {month: 'short'})} ${datePlusSix.getDate()}`;

    const datePlusSeven = new Date(datePlusSix);
    for (let i = 0; i < 1;) {
      datePlusSeven.setDate(datePlusSeven.getDate() + 1);
      if (datePlusSeven.getDay() !== 0) {
        i++;
      }
    }
    const formattedDatePlusSeven = `${datePlusSeven.toLocaleString('default', {month: 'short'})} ${datePlusSeven.getDate()}`;

    const truckSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="a" width="34" height="25" viewBox="0 0 42 32" style="fill: #00713A;width:20px;"><path id="b" d="m42,16.69l-7.65-9.84h-6.68V0H0v27.16h4.52c.36,2.72,2.75,4.84,5.66,4.84s5.3-2.12,5.66-4.84h6.77c.36,2.72,2.75,4.84,5.66,4.84s5.3-2.12,5.66-4.84h8.07v-10.47Zm-31.82,13.43c-2.09,0-3.79-1.65-3.79-3.67s1.7-3.67,3.79-3.67,3.79,1.65,3.79,3.67-1.7,3.67-3.79,3.67Zm12.49-4.84h-6.9c-.56-2.5-2.85-4.37-5.6-4.37s-5.04,1.88-5.6,4.37H1.95V1.88h23.78v19.63c-1.53.74-2.68,2.11-3.05,3.77Zm5.6,4.84c-2.09,0-3.79-1.65-3.79-3.67s1.7-3.67,3.79-3.67,3.79,1.65,3.79,3.67-1.7,3.67-3.79,3.67Zm11.78-4.84h-6.18c-.56-2.5-2.85-4.37-5.6-4.37-.21,0-.4.04-.61.06v-12.23h5.71l6.68,8.59v7.96Z"/></svg>`;
    const tooltipSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="a" width="16" height="16" viewBox="0 0 32 32" style="fill: gray;width:16px;margin-top:-5px;"><path id="b" d="m16,0C7.16,0,0,7.16,0,16s7.16,16,16,16,16-7.16,16-16S24.84,0,16,0Zm1.6,26.5h-3v-3h3v3Zm1.04-9.23c-.7.29-1.16.98-1.16,1.74v1.5h-2.96v-1.5c0-1.99,1.19-3.77,3.01-4.52,1.41-.58,2.01-1.43,2.01-2.76,0-1.76-1.56-3.22-3.54-3.22s-3.54,1.47-3.54,3.22v1.5h-2.96v-1.5c0-3.46,2.93-6.22,6.5-6.22s6.5,2.76,6.5,6.22c0,2.59-1.36,4.51-3.86,5.54Z"/></svg>`;

    const addtocartcheck = document.querySelector('.quantity-submit-row__submit');
    if(addtocartcheck){
    const isAvail = (document.querySelector('.quantity-submit-row__submit input').value.toLowerCase().trim().includes('add to cart'))

    if (isAvail) {
      availableElem.innerHTML = `
                  <div class="tooltip-container" style="display:none">
                    ${truckSVG}
                    <div style="color:#454545;font-size:15px;font-weight:400;margin-left:12px;">Estimated arrival to you: <span style="color: #00713A;margin:0 1px;font-weight:700;">${formattedDatePlusSeven}</span> or <span style="color: #00713A;font-style: normal;margin:0 1px;font-weight:400;">sooner</span>
                      <div class="tooltip">
                        ${tooltipSVG}                      
                        <div class="tooltip-content" style="color:#454545;font-size:15px;">
                          <span class="close-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>
                          <div class="section" style="padding-top:10px;">
                            <strong>UPS Ground</strong>
                            <p style="margin:5px 0 0;font-weight: 400;">Estimated arrival to you: <span style="color: #00713A;font-weight: 700;">${formattedDatePlusSix}</span></p>
                          </div>
                          <hr style="height:0;margin: 12px 0;">
                          <div class="section">
                            <strong>UPS SurePost</strong>
                            <p style="margin:5px 0 0;font-weight: 400;">Estimated arrival to you: <span style="color: #00713A;font-weight: 700;">${formattedDatePlusSeven}</span></p>
                          </div>
                          <hr style="height:0;margin: 12px 0;">
                          <div class="section" style="margin-bottom:5px; 0">
                            <em style="font-weight: 400;">You can select the delivery method during checkout</em>
                          </div>
                          <div class="arrow"></div>
                        </div>
                      </div>                    
                    </div>  
                    <span style="padding-left: 4px"> | FREE Shipping over $99*</span>                
                  </div>`;

      const tooltipIcon = availableElem.querySelector('.tooltip');
      const tooltipContent = availableElem.querySelector('.tooltip-content');
      const closeBtn = availableElem.querySelector('.close-btn');

      tooltipIcon.addEventListener('click', function (e) {
        if (e.target.closest('.tooltip-content')) return;

        const isTooltipVisible = tooltipContent.style.display === 'block';
        tooltipContent.style.display = isTooltipVisible ? 'none' : 'block';
      });

      closeBtn.addEventListener('click', function () {
        tooltipContent.style.display = 'none';
      });

      document.addEventListener('click', function (e) {
        if (tooltipContent.style.display !== 'block') {
          return;
        }

        if (e.target.closest('.tooltip-content') || e.target.closest('.tooltip')) {
          return;
        }

        tooltipContent.style.display = 'none';
      });
    }
   } else {
      availableElem.innerHTML = '';
    }
  }
}

(function ($) {
  var $ = jQuery = $;
  
  // Turn a <select> tag into clicky boxes
  // Use with: $('select').clickyBoxes()
  $.fn.clickyBoxes = function (prefix) {
    
    if (prefix == 'destroy') {
      
      $(this).off('.clickyboxes');
      $(this).next('.clickyboxes').off('.clickyboxes');
    } else {
      
      return $(this).filter('select:not(.clickybox-replaced)').addClass('clickybox-replaced').each(function () {
        // Make sure rows are unique
        var prefix = prefix || $(this).attr('id'); // Create container
       
        var $optCont = $('<ul class="clickyboxes"/>').attr('id', 'clickyboxes-' + prefix).data('select', $(this)).insertAfter(this);
        var $label;
        if ($(this).is('[id]')) {
          $label = $('label[for="' + $(this).attr('id') + '"]'); // Grab real label
        } else {
          $label = $(this).siblings('label'); // Rough guess
        }

        if ($label.length > 0) {
          $optCont.addClass('options-' + removeDiacritics($label.text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, ''));
        } // Add options to container

        $(this).find('option').each(function () {
          $('<li/>').appendTo($optCont).append($('<a href="#"/>').attr('data-value', $(this).val()).html($(this).html()).addClass('opt--' + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '')));
        }); // Select change event

        $(this).hide().addClass('replaced').on('change.clickyboxes keyup.clickyboxes', function () {
          // Choose the right option to show
          var val = $(this).val();
          $optCont.find('a').removeClass('active').filter(function () {
            return $(this).attr('data-value') == val;
          }).addClass('active');
        }).trigger('keyup'); // Initial value
        // Button click event

        $optCont.on('click.clickyboxes', 'a', function () {
          if (!$(this).hasClass('active')) {
            var $clicky = $(this).closest('.clickyboxes');
            $clicky.data('select').val($(this).data('value')).trigger('change');
            $clicky.trigger('change');
          }

          return false;
        });
      });
    }
  };


  theme.buildGalleryViewer = function (config) {
    // create viewer
    var $allContainer = $('<div class="gallery-viewer gallery-viewer--pre-reveal">');
    var $zoomContainer = $('<div class="gallery-viewer__zoom">').appendTo($allContainer);
    var $thumbContainer = $('<div class="gallery-viewer__thumbs">').appendTo($allContainer);
    var $controlsContainer = $('<div class="gallery-viewer__controls">').appendTo($allContainer);
    var $close = $('<a class="gallery-viewer__button gallery-viewer__close" href="#">').html(config.close).appendTo($controlsContainer);
    var $right = $('<a class="gallery-viewer__button gallery-viewer__prev" href="#">').html(config.prev).appendTo($controlsContainer);
    var $left = $('<a class="gallery-viewer__button gallery-viewer__next" href="#">').html(config.next).appendTo($controlsContainer);
    var $currentZoomImage = null; // add images

    for (var i = 0; i < config.images.length; i++) {
      var img = config.images[i];
      $('<a class="gallery-viewer__thumb" href="#">').data('zoom-url', img.zoomUrl).html(img.thumbTag).appendTo($thumbContainer);
    }

    if (config.images.length === 1) {
      $allContainer.addClass('gallery-viewer--single-image');
    } // helper function for panning an image

    var panZoomImage = function panZoomImage(inputX, inputY) {
      // do nothing if the image fits, pan if not
      var doPanX = $currentZoomImage.width() > $allContainer.width();
      var doPanY = $currentZoomImage.height() > $allContainer.height();

      if (doPanX || doPanY) {
        var midX = $allContainer.width() / 2;
        var midY = $allContainer.height() / 2;
        var offsetFromCentreX = inputX - midX;
        var offsetFromCentreY = inputY - midY; // the offsetMultipler ensures it can only pan to the edge of the image, no further

        var finalOffsetX = 0;
        var finalOffsetY = 0;

        if (doPanX) {
          var offsetMultiplierX = ($currentZoomImage.width() - $allContainer.width()) / 2 / midX;
          finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX);
        }

        if (doPanY) {
          var offsetMultiplierY = ($currentZoomImage.height() - $allContainer.height()) / 2 / midY;
          finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY);
        }

        $currentZoomImage.css('transform', ['translate3d(', finalOffsetX, 'px, ', finalOffsetY, 'px, 0)'].join(''));
      }
    }; // set up events
    // event: select thumbnail - zoom it

    $allContainer.on('click.galleryViewer select.galleryViewer', '.gallery-viewer__thumb', function (evt) {
      evt.preventDefault(); // set active

      $(this).addClass('gallery-viewer__thumb--active').siblings('.gallery-viewer__thumb--active').removeClass('gallery-viewer__thumb--active'); // replace zoom image

      $currentZoomImage = $('<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">');
      $currentZoomImage.on('load', function () {
        $(this).off('load');
        $(this).css({
          visibility: '',
          top: $allContainer.height() / 2 - $(this).height() / 2,
          left: $allContainer.width() / 2 - $(this).width() / 2
        });
        panZoomImage(evt.clientX, evt.clientY);
      }).attr('src', $(this).data('zoom-url'));
      $zoomContainer.html($currentZoomImage);
    }); // event: pan

    $allContainer.on('mousemove.galleryViewer touchmove.galleryViewer', function (evt) {
      if (evt.type === 'touchmove') {
        var touch = evt.touches[0];
        panZoomImage(touch.clientX, touch.clientY);
      } else {
        panZoomImage(evt.clientX, evt.clientY);
      }
    }); // event: prevent pan while swiping thumbnails

    $allContainer.on('touchmove.galleryViewer', '.gallery-viewer__thumbs', function (evt) {
      evt.stopPropagation();
    }); // event: next thumbnail

    $allContainer.on('click.galleryViewer', '.gallery-viewer__next', function (evt) {
      evt.preventDefault();
      var $next = $thumbContainer.find('.gallery-viewer__thumb--active').next();

      if ($next.length === 0) {
        $next = $thumbContainer.find('.gallery-viewer__thumb:first');
      }

      $next.trigger('select');
    }); // event: previous thumbnail

    $allContainer.on('click.galleryViewer', '.gallery-viewer__prev', function (evt) {
      evt.preventDefault();
      var $prev = $thumbContainer.find('.gallery-viewer__thumb--active').prev();

      if ($prev.length === 0) {
        $prev = $thumbContainer.find('.gallery-viewer__thumb:last');
      }

      $prev.trigger('select');
    }); // event: close

    $allContainer.on('click.galleryViewer', '.gallery-viewer__close', function (evt) {
      evt.preventDefault(); // destroy events

      $allContainer.off('.galleryViewer'); // begin exit transition

      $allContainer.addClass('gallery-viewer--transition-out'); // remove after transition

      var transitionDelay = $allContainer.css('transition-duration');
      transitionDelay = transitionDelay.indexOf('ms') > -1 ? parseFloat(transitionDelay) : parseFloat(transitionDelay) * 1000;
      setTimeout(function () {
        $allContainer.remove();
        $('html').removeClass('gallery-viewer-open');
      }, transitionDelay);
    }); // initialise
    // - clear any remnants of failed previous closure

    $('html').removeClass('gallery-viewer-open');
    $('.gallery-viewer').remove(); // - insert into page

    $('html').addClass('gallery-viewer-open');
    $allContainer.appendTo('body'); // - select first thumbnail

    $thumbContainer.find('.gallery-viewer__thumb:eq(' + (config.current > 0 ? config.current : 0) + ')').trigger('select'); // - reveal

    setTimeout(function () {
      $allContainer.removeClass('gallery-viewer--pre-reveal');
    }, 10);
  };

  theme.productGallerySlideshowTabFix = function (slides, current) {
    // tabindex everything to prevent tabbing into hidden slides
    $(slides[current]).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function () {
      if (typeof $(this).data('theme-slideshow-original-tabindex') !== 'undefined') {
        if ($(this).data('theme-slideshow-original-tabindex') === false) {
          $(this).removeAttr('tabindex');
        } else {
          $(this).attr('tabindex', $(this).data('theme-slideshow-original-tabindex'));
        }
      } else {
        $(this).removeAttr('tabindex');
      }
    });
    $(slides).not(slides[current]).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function () {
      if (typeof $(this).data('theme-slideshow-original-tabindex') === 'undefined') {
        $(this).data('theme-slideshow-original-tabindex', typeof $(this).attr('tabindex') !== 'undefined' ? $(this).attr('tabindex') : false);
        $(this).attr('tabindex', '-1');
      }
    });
  }; // container must be an element higher up the tree than the gallery

  theme.initProductGallery = function (container) {
    var $gallery = $('.gallery', container);

    if ($gallery.hasClass('gallery-initialised')) {
      return;
    }

    $gallery.addClass('gallery-initialised'); /// Init main image slideshow

    $(document).ready(function() {
      try {
        $('.product-slideshow', container).slick({
          // Your initialization options...
        });
      }
      catch(err) {
        
      }

      // Wait a bit after initialization and then attach the event
      setTimeout(() => {
        $('.product-slideshow .slick-slide', container).on('dragstart', function(e) {
          console.log('Dragstart event triggered'); // Check if this logs when trying to drag
          e.preventDefault();
        });
      }, 1000); // Adjust the timing as necessary to test
    });
    

    $('.product-slideshow', container).each(function () {
      var $slideshow = $(this).on('init', function (evt, slick) {
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).on('beforeChange', function (evt, slick, current, next) {
        $($(this).closest('.gallery').find('.thumbnails a')[next]).trigger('selectFromSlick');
      }).slick({
        autoplay: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        useTransform: true,
        dots: false,
        arrows: true,
        centerMode: true,
        slidesToShow: 1,
        appendArrows: $(this).siblings('.slideshow-controls').find('.slideshow-controls__arrows'),
        appendDots: $(this).siblings('.slideshow-controls').find('.slideshow-controls__dots'),
        prevArrow: '<button type="button" class="slick-product-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
        nextArrow: '<button type="button" class="slick-product-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
        responsive: [{
          breakpoint: 767,
          settings: {
            dots: true,
            arrows: false,
            fade: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false
          }
        }]
      }); // media initialisation

      theme.productGallerySlideshowTabFix($slideshow.slick('getSlick').$slides, $slideshow.slick('getSlick').currentSlide);
      $slideshow.on('afterChange', function (evt, slick, current) {
        // notify media of visibility
        $('.product-media--activated').removeClass('product-media--activated').trigger('mediaHidden');
        $('.product-media', slick.$slides[current]).addClass('product-media--activated').trigger('mediaVisible'); // fix tabbing

        theme.productGallerySlideshowTabFix(slick.$slides, current); // resize quickbuy

        $(this).closest('.quickbuy-container').trigger('changedsize');
      }); // if in quickbuy, trigger resize after slideshow change

      if ($(container).closest('.collection-listing').length > 0) {
        $slideshow.on('afterChange', function () {
          $(this).closest('.quickbuy-container').trigger('changedsize');
        });
      }
    });
    var $thumbnails = $('.thumbnails', container);

    if ($thumbnails.length) {
      var carouselVisibleItemCount = 6;
      var isCarousel = false; /// Screen-width based initialisation of thumbnail carousels

      var assessCarousel = function assessCarousel() {
        if ($thumbnails.is(':visible')) {
          // thumbnails are visible (i.e. not mobile)
          if (Math.abs($thumbnails.outerWidth() - $thumbnails.parent().width()) > 20) {
            // thumbnail container is drastically different in size to main image - destroy carousel
            if (isCarousel) {
              isCarousel = false;
              theme.beforeCarouselUnloadEventBlockFix($thumbnails);
              $thumbnails.removeClass('owl-carousel').data('owl.carousel').destroy();
            }
          } else {
            // thumbnails are in a column - init carousel
            if (!isCarousel) {
              isCarousel = true; // fix for event propagation in nested owl carousels

              theme.beforeCarouselLoadEventBlockFix($thumbnails);
              $thumbnails.addClass('owl-carousel').on('initialized.owl.carousel', function () {
                $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
              }).owlCarousel({
                items: carouselVisibleItemCount,
                dots: false,
                margin: 7
              });
            }
          }
        }
      };

      $(window).on('debouncedresize.productGallery', assessCarousel);
      assessCarousel();
      $(container).data('assessCarouselCallback', assessCarousel); /// Thumbnail click - in carousel

      $('.gallery', container).on('click select selectFromSlick', '.thumbnails.owl-carousel a', function (e) {
        e.preventDefault();
        var $carouselItem = $(this).parent();

        if (e.type != 'selectFromSlick') {
          // from click or variant image? change main image
          $(this).closest('.gallery').find('.slideshow').slick('slickGoTo', $carouselItem.index());
        } else {
          // change to active state comes from the main slideshow change event
          // show the highlight
          $(this).addClass('selected').parent().siblings().find('a').removeClass('selected'); // adjust thumbnail carousel if not on-screen

          var shelfStart = $carouselItem.parent().children('.active:first').index();
          var shelfEnd = shelfStart + carouselVisibleItemCount - 1;
          var currentIndex = $carouselItem.index();

          if (currentIndex < shelfStart) {
            // selected is to left of shelf - move carousel right to show
            $carouselItem.closest('.owl-carousel').trigger('to.owl.carousel', currentIndex);
          } else if (currentIndex > shelfEnd) {
            // selected is to right of shelf - move carousel left to show
            $carouselItem.closest('.owl-carousel').trigger('to.owl.carousel', Math.max(0, currentIndex - carouselVisibleItemCount + 1));
          }
        }
      }); /// Thumbnail click - beside

      $('.gallery', container).on('click select selectFromSlick', ' .thumbnails:not(.owl-carousel) a', function (e) {
        e.preventDefault();

        if (e.type != 'selectFromSlick') {
          // from click or variant image? change main image
          $(this).closest('.gallery').find('.slideshow').slick('slickGoTo', $(this).index());
        } else {
          // change to active state comes from the main slideshow change event
          $(this).addClass('selected').siblings('.selected').removeClass('selected');
        }
      });
    }
  };

  theme.destroyProductGallery = function (container) {
    $(window).off('.productGallery');
    var $gallery = $('.gallery', container).off('click select selectFromSlick');
    theme.ProductMedia.destroy($gallery);
    $('.slick-slider', container).slick('unslick').off('init beforeChange afterChange');
    $('.owl-carousel', container).each(function () {
      theme.beforeCarouselUnloadEventBlockFix(this);
      $(this).data('owl.carousel').destroy();
    });
  };


  theme.ProductTemplateSection = new function () {
    this.onSectionLoad = function (target) {
      theme.initToggleTargets();
      theme.classUpTextLinks(target); /// Init store availability if applicable

      $('[name="id"]', target).trigger('optionate');
      theme.initProductGallery(target);
      theme.ProductBlockManager.loadImages(target); // click review rating under title
    };

    this.onSectionUnload = function (target) {
      theme.destroyProductGallery(target);
      theme.OptionManager.unloadProductOptions($('[name="id"]', target));
      $('.size-chart-link', target).off('click');
    };
  }();

  if (theme.settings.show_size_chart) {
    // size chart link
    $(document).on('click', '.size-chart-link', function () {
      $.fancybox($.extend({}, theme.fbOpts(), {
        showNavArrows: false,
        content: $(this).closest('.size-chart-container').find('.size-chart-content').html()
      }));
      return false;
    });
  }

  $(document).on('optionate', '[name="id"]', function (e) {
    
    // no product data? fetch using json now
    var $form = $(this).closest('form');
    var productId = $form.data('product-id');
 
    if (theme.productData[productId] || document.getElementById('ProductJson-' + productId)) {
      // reveal dynamic checkout buttons
      if ($(this).closest('form').find('.dynamic-checkout-buttons').each(function () {
        $(this).before($(this).html()).remove();
      }).length > 0 && window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    } else {
      console.log('Product data missing');
    } // events on option change
    
    checkShippingAvailability();

    updateButtonText();

     setupButtonTextObserver();
    
    // Variant Changed
    $(this).on('variantChanged', function (evt, variant) {

      var $labelCont = $form.closest('.detail').find('.productlabel-container');
      $labelCont.find('.productlabel').remove();
      $labelCont.append($('#variant-label-' + variant.id).html());

      document.querySelector('.variant-id').setAttribute('data-variant', variant.id);

      var quantity = document.querySelector('#quantity');
      

      if (quantity) {
        var currentMax = theme.productVariantInventory[variant.id] || 1;
        // Set value of max based on current variant inventory
        quantity.setAttribute('data-max', currentMax);
        var val = isNaN(+quantity.value) ? 0 : +quantity.value;
        // Adjust the current value to be at max inventory if it's over
        quantity.value = val > currentMax ? currentMax : Math.max(1, val);
      } 

     checkShippingAvailability();
      if (typeof checkWidthAvailability === 'function') {
         checkWidthAvailability();
       }

       updateButtonText();
      var waitForKlaviyo = setInterval(function () {
        var klaviyoBtn = document.querySelector('.klaviyo-bis-trigger');

        if (klaviyoBtn) {
          clearInterval(waitForKlaviyo);
          if (document.querySelector('.productlabel.soldout')) {
            klaviyoBtn.style.setProperty('display', 'block', 'important');
          } else {
            klaviyoBtn.style.setProperty('display', 'none', 'important');
          }
        }
      }, 500);
    });
    theme.OptionManager.initProductOptions(this); // show box-style options
    
    // Regex find classes for size wrappers that don't say "size"
    $form.find('.selector-wrapper').filter(function () {
      return this.id.match(/^selector-wrapper--mens.*/);
    }).addClass('selector-wrapper--siz').addClass('selector-wrapper--siznew');

    

    $form.find('.selector-wrapper').filter(function () {
      return this.id.match(/^selector-wrapper--womens.*/);
    }).addClass('selector-wrapper--siz');
    
    var $clickies = $form.find('[data-make-box]').addClass('has-clickyboxes').find('select').clickyBoxes(); // If we have clicky boxes, add the disabled-state to options that have no valid variants

    if ($clickies.length > 0) {
      // product form may have changed height. If in quick buy, resize container
      $(this).closest('.quickbuy-container').trigger('changedsize');
      var productData = theme.OptionManager.getProductData($form); // each option

      for (var optionIndex = 0; optionIndex < productData.options.length; optionIndex++) {
        // list each value for this option
        var optionValues = {};

        for (var variantIndex = 0; variantIndex < productData.variants.length; variantIndex++) {
          var variant = productData.variants[variantIndex];

          if (typeof optionValues[variant.options[optionIndex]] === 'undefined') {
            optionValues[variant.options[optionIndex]] = false;
          } // mark true if an option is available

          if (variant.available) {
            optionValues[variant.options[optionIndex]] = true;
          }
        } // mark any completely unavailable options

        for (var key in optionValues) {
          if (!optionValues[key]) {
            $('.selector-wrapper:eq(' + optionIndex + ') .clickyboxes li a', $form).filter(function () {
              return $(this).attr('data-value') == key;
            }).addClass('unavailable');
          }
        }
      }
    } // select2

    $form.find('.selector-wrapper:not([data-make-box]) select').each(function () {
      theme.select2.init($(this));
    }); // unload clickies & select2

    $form.find('.selector-wrapper--siz select').each(function () {
      theme.select2.init($(this));
    });

    $form.find('.selector-wrapper--uni select').each(function () {
      theme.select2.init($(this));
    });

    $(this).on('unloading', function () {
      $(this).off('unloading variantChanged'); // unload clickyboxes

      $form.find('.selector-wrapper select.clickybox-replaced').clickyBoxes('destroy'); // unload select2

      theme.select2.destroyAllIn($form.find('.selector-wrapper'));
    });
  }); /// Galleries (inc. product page)
  // when variant changes, and the variant has an image

  $(document).on('variantImageSelected', '.gallery', function (e, data) {
    // get image src
    var mediaId = data.featured_media.id; // locate matching thumbnail

    $(this).find('.thumbnails a[data-media-id="' + mediaId + '"]:first').trigger('select');
  }); // click main product image (launch gallery)

  $(document).on('click', '.product-detail .gallery .main-image a.show-gallery', function () {
    var images = [];
    var currentIndex = 0;
    var $thumbs = $(this).closest('.gallery').find('.thumbnails .thumbnail--media-image');

    if ($thumbs.length) {
      $thumbs.each(function () {
        var $imgThumb = $(this).find('.rimage-outer-wrapper').clone();
        $imgThumb.find('.lazyloaded').removeClass('lazyloaded').addClass('lazyload').parent().addClass('lazyload--placeholder');
        images.push({
          thumbTag: $imgThumb,
          zoomUrl: $(this).attr('href')
        });
      });
      $thumbs.each(function (thisIndex) {
        if ($(this).hasClass('selected')) {
          currentIndex = thisIndex;
          return false;
        }
      });
    } else {
      var $imgThumb = $(this).find('.rimage-outer-wrapper').clone();
      $imgThumb.find('.lazyloaded').removeClass('lazyloaded').addClass('lazyload').parent().addClass('lazyload--placeholder');
      images.push({
        thumbTag: $imgThumb,
        zoomUrl: $(this).attr('href')
      });
    }

    theme.buildGalleryViewer({
      images: images,
      current: currentIndex,
      prev: theme.icons.chevronLeft,
      next: theme.icons.chevronRight,
      close: theme.icons.close
    });
    return false;
  });

  // Quantity buttons
  $(document).on('click', '.quantity-wrapper [data-quantity]', function () {
    var adj = $(this).data('quantity') == 'up' ? 1 : -1;
    var $qty = $(this).closest('.quantity-wrapper').find('[name=quantity]');
    var max = +$qty[0].getAttribute('data-max');
    var val = isNaN(+$qty.val()) ? 0 : +$qty.val(); // set to 0 if not a number

    // Do nothing if we would be going over the max available inventory
    if (val + adj > max) return false;

    $qty.val(Math.max(1, val + adj)).trigger('change');
    return false;
  });

  // Keyboard input on quantity
  $(document).on('keyup', '.quantity-wrapper [name=quantity]', function () {
    if (!this.value) return;
    var val = isNaN(+this.value) ? 0 : +this.value; // set to 0 if not a number
    var max = +this.getAttribute('data-max');
    this.value = val > max ? max : Math.max(1, val);
  });

  theme.Sections.register('product-template', theme.ProductTemplateSection, {
    deferredLoad: false
  }); 
  $("ul.clickyboxes li a").on("click", function(){
    var val = $(this).attr("data-values");
    var lowercaseVal = val.toLowerCase();
    $(this).parents(".has-clickyboxes").find(".selected_varname").html(lowercaseVal);
    var size_div = $(this).parents("#selector-wrapper--siz");
    var width_div = $(this).parents("#selector-wrapper--wid");
    var uni_div = $(this).parents(".options-uni");

    if (size_div.length > 0 && $('.product-sticky-size').length > 0) {
      $('.product-sticky-size span').html(lowercaseVal);
    }

    if (uni_div.length > 0 && $('.product-sticky-size').length > 0) {
      $('.product-sticky-size span').html(lowercaseVal);
    }

    if (width_div.length > 0 && $('.product-sticky-width').length > 0) {
      $('.product-sticky-width span').html(lowercaseVal);
    }
  });
  setTimeout(function(){
  $("ul.clickyboxes li a.active").each(function(){
    var val = $(this).attr("data-values");
    var lowercaseVal = val;
      try {
        lowercaseVal = val.toLowerCase();
      }
      catch(err) {
        
      }
    //console.log(val);
    $(this).parents(".has-clickyboxes").find(".selected_varname").html(lowercaseVal);
    var size_div = $(this).parents("#selector-wrapper--siz");
    var width_div = $(this).parents("#selector-wrapper--wid");
    var uni_div = $(this).parents(".options-uni");

    if (size_div.length > 0 && $('.product-sticky-size').length > 0) {
      $('.product-sticky-size span').html(lowercaseVal);
    }

    if (uni_div.length > 0 && $('.product-sticky-size').length > 0) {
      $('.product-sticky-size span').html(lowercaseVal);
    }

    if (width_div.length > 0 && $('.product-sticky-width').length > 0) {
      $('.product-sticky-width span').html(lowercaseVal);
    }
  });
  },500);
  $("#selector-wrapper--wid li p").each(function(){
    var thishtml = $(this).html();
    if(thishtml == 'Regular'){
      $(this).parents("li a").attr("data-values",thishtml);
    }
  })
  $("ul.clickyboxes li p").each(function(){
      var text = $(this).text();
      $(this).parents("li a").attr("data-values",text);   
  })
})(theme.jQuery); 
 